import { createSlice, current } from '@reduxjs/toolkit'
import moment from 'moment'
import 'moment/locale/es'
import { reportStructure } from '@src/utility/reportStructure'

const initialState = {
    workGroupId: null,
    processStep: 1,
    vehiclesGlobal: [],
    reasonsGlobal: [],
    workGroupMembersGlobal: [],
    currentPlanning: [],
    planningDates: [],
    weeksGlobal: [],
    isNextWorkGroupNumber: false,
    radiosConfig1Redux: [],
    currentDataPlanning: null,
    isErrorTicketImg: false,
    reportData: null,
    reportDataServer: null,
    siteVisitReportId: null,
    reportStructure,
    visitTypeId: null,
    hospedajeCasetasInfo: []
}

export const workGroupsSlice = createSlice({
    name: 'workgroups',
    initialState,
    reducers: {
        setWorkGroupId: (state, action) => {
            state.workGroupId = action.payload
        },
        setProcessStep: (state, action) => {
            state.processStep = action.payload
        },
        setVehiclesGlobal: (state, action) => {
            state.vehiclesGlobal = action.payload
        },
        setReasonsGlobal: (state, action) => {
            state.reasonsGlobal = action.payload
        },
        setWorkgroupMembersGlobal: (state, action) => {
            state.workGroupMembersGlobal = action.payload
        },
        setCurrentPlanning: (state, action) => {
            const currentPlanning = action.payload
            const { list_dates_range: planningDates } = currentPlanning
            state.currentPlanning = currentPlanning
            state.planningDates = planningDates.map((date, index) => ({
                id: Math.random().toString(36).substring(7) + Date.now().toString(36),
                originalValue: date,
                formattedValue: moment(date).format('dddd D [de] MMMM [,] YYYY'),
                active: index === 0 ? true : false
            }))
        },
        setPlanningDates: (state, action) => {
            state.planningDates = action.payload
        },
        setWeeksGlobal: (state, action) => {
            state.weeksGlobal = action.payload
        },
        setIsNextWorkGroupNumber: (state, action) => {
            state.isNextWorkGroupNumber = action.payload
        },
        resetState: (state) => {
            return initialState
        },
        setRadiosConfig1Redux: (state, action) => {
            state.radiosConfig1Redux = action.payload
        },
        setCurrentWeek: (state, action) => {
            state.currentDataPlanning = action.payload
        },
        setIsErrorTicketImg: (state, action) => {
            state.isErrorTicketImg = action.payload
        },
        setReportData: (state, action) => {
            state.reportData = action.payload
        },
        setReportDataServer: (state, action) => {
            state.reportDataServer = action.payload
        },
        setSiteVisitReportId: (state, action) => {
            state.siteVisitReportId = action.payload
        },
        setPropertyReportValue: (state, action) => {
            const { property, value } = action.payload
            state.reportStructure = { ...state.reportStructure, [property]: value }
        },
        setFullStructureReport: (state, action) => {
            state.reportStructure = { ...action.payload }
        },
        setVisitTypeId: (state, action) => {
            state.visitTypeId = action.payload
        },
        updateHospedajeCasetasInfo: (state, action) => {
            const { planningDate, property, value } = action.payload
            let hospedajeCasetasInfo = [...current(state.hospedajeCasetasInfo)]
            const newState = hospedajeCasetasInfo.map((el) => {
                return el.planningDate === planningDate ? { ...el, [property]: value, changed: true } : el
            })
            state.hospedajeCasetasInfo = newState
        },
        setHospedajeCasetasInfo: (state, action) => {
            state.hospedajeCasetasInfo = action.payload
        }
    }
})

export const {
    setWorkGroupId,
    setProcessStep,
    setVehiclesGlobal,
    setReasonsGlobal,
    setWorkgroupMembersGlobal,
    setCurrentPlanning,
    setPlanningDates,
    setWeeksGlobal,
    setIsNextWorkGroupNumber,
    resetState,
    setRadiosConfig1Redux,
    setCurrentWeek,
    setIsErrorTicketImg,
    setReportData,
    setSiteVisitReportId,
    setReportDataServer,
    setPropertyReportValue,
    setFullStructureReport,
    setVisitTypeId,
    setHospedajeCasetasInfo,
    updateHospedajeCasetasInfo
} = workGroupsSlice.actions
export default workGroupsSlice.reducer
